export const USER_REGISTER_RESET = 'USER_REGISTER_RESET'
export const USER_REGISTER_SET_CREATED = 'USER_REGISTER_SET_CREATED'
export const USER_REGISTER_SET_ERROR = 'USER_REGISTER_SET_ERROR'
export const USER_REGISTER_SET_VIOLATIONS = 'USER_REGISTER_SET_VIOLATIONS'
export const USER_REGISTER_TOGGLE_LOADING = 'USER_REGISTER_TOGGLE_LOADING'
